import { render, staticRenderFns } from "./AsistenciaHogar.vue?vue&type=template&id=10ba1548&scoped=true&"
var script = {}
import style0 from "./AsistenciaHogar.vue?vue&type=style&index=0&id=10ba1548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ba1548",
  null
  
)

export default component.exports